function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.03,
    y: 6.005,
    width: 30,
    height: 17.995,
    style: {
      fill: "#2a936a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".03 6.634 .03 23.371 27.941 15.003 .03 6.634",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".03 6.634 .03 23.371 27.941 15.003 .03 6.634",
    style: {
      fill: "#ffc20e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".03 6.008 .03 7.261 25.853 15.003 .03 22.745 .03 23.997 30.03 15.003 .03 6.008",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".03 6.706 .03 23.3 13.867 15.003 .03 6.706",
    style: {
      fill: "#be1e2d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".03 6 .03 7.399 12.7 14.997 .03 22.595 .03 23.995 15.034 14.997 .03 6",
    style: {
      fill: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/GY.e820a99ee9497bc4e69114e241811040.svg";
export { ForwardRef as ReactComponent };